/**
 * Vue Router設定ファイル
 * アプリケーションのルーティング設定とページコンポーネントの定義を行う
 */
import Vue from "vue";
import Router from "vue-router";
// メインコンポーネント（頻繁に使用されるため同期読み込み）
import home from "@/components/home";

// ページコンポーネント（遅延読み込みでパフォーマンス向上）
const login = () => import("@/components/page/login");
const D001 = () => import("@/components/page/D001-optimized");
const D001Dashboard = () => import("@/components/page/D001-dashboard");
const E001 = () => import("@/components/page/E001-optimized");
const M001 = () => import("@/components/page/M001-optimized");
const M004 = () => import("@/components/page/M004-optimized");
const M011 = () => import("@/components/page/M011-optimized");
const O001 = () => import("@/components/page/O001-optimized");
const F001 = () => import("@/components/page/F001-optimized");
const G001 = () => import("@/components/page/G001-optimized");
const H001 = () => import("@/components/page/H001-optimized");
const Q001 = () => import("@/components/page/Q001-optimized");
const K001 = () => import("@/components/page/K001-optimized");
const C001 = () => import("@/components/page/C001-optimized");
const J001 = () => import("@/components/page/J001-optimized");
const E002 = () => import("@/components/page/E002-optimized");
const F002 = () => import("@/components/page/F002-optimized");
const G002 = () => import("@/components/page/G002-optimized");
const Q002 = () => import("@/components/page/Q002-optimized");
const J002 = () => import("@/components/page/J002-optimized");
const C002 = () => import("@/components/page/C002-optimized");
const S002 = () => import("@/components/page/S002-optimized");
const F003 = () => import("@/components/page/F003-optimized");
const M002 = () => import("@/components/page/M002-optimized");
const M012 = () => import("@/components/page/M012-optimized");
const S001 = () => import("@/components/page/S001-optimized");
const R001 = () => import("@/components/page/R001-optimized");
const O002 = () => import("@/components/page/O002-optimized");
const O003 = () => import("@/components/page/O003-optimized");
const D003 = () => import("@/components/page/D003-optimized");
const PCA01 = () => import("@/components/page/PCA01-optimized");
const S00101 = () => import("@/components/page/S00101-optimized");
const C00101 = () => import("@/components/page/C00101-optimized");
// 承認フロー関連コンポーネント
const A001 = () => import("@/components/page/A001-optimized");
const A002 = () => import("@/components/page/A002-optimized");
const A003 = () => import("@/components/page/A003-optimized");
// 部署管理関連コンポーネント
const B001 = () => import("@/components/page/B001-optimized");
const B002 = () => import("@/components/page/B002-optimized");
// 引当計画管理関連コンポーネント
const P001 = () => import("@/components/page/P001-optimized.vue");
const P002 = () => import("@/components/page/P002-optimized.vue");
const P001Test = () => import("@/components/page/P001-test.vue");
Vue.use(Router);

var router = new Router({
  base: process.env.ROOT_BASE,
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "login",
      component: login,
    },
    {
      path: "/home",
      name: "home",
      component: home,
      children: [
        {
          path: "/D001",
          name: "/D001",
          component: D001,
        },
        {
          path: "/D001-dashboard",
          name: "/D001-dashboard",
          component: D001Dashboard,
        },
        {
          path: "/E001",
          name: "/E001",
          component: E001,
        },
        {
          path: "/M001",
          name: "/M001",
          component: M001,
        },
        {
          path: "/M004",
          name: "/M004",
          component: M004,
        },
        {
          path: "/M011",
          name: "/M011",
          component: M011,
        },
        {
          path: "/O001",
          name: "/O001",
          component: O001,
        },
        {
          path: "/F001",
          name: "/F001",
          component: F001,
        },
        {
          path: "/G001",
          name: "/G001",
          component: G001,
        },
        {
          path: "/H001",
          name: "/H001",
          component: H001,
        },
        {
          path: "/Q001",
          name: "/Q001",
          component: Q001,
        },
        {
          path: "/K001",
          name: "/K001",
          component: K001,
        },
        {
          path: "/C001",
          name: "/C001",
          component: C001,
        },
        {
          path: "/J001",
          name: "/J001",
          component: J001,
        },
        {
          path: "/E002",
          name: "/E002",
          component: E002,
        },
        {
          path: "/F002",
          name: "/F002",
          component: F002,
        },
        {
          path: "/G002",
          name: "/G002",
          component: G002,
        },
        {
          path: "/Q002",
          name: "/Q002",
          component: Q002,
        },
        {
          path: "/J002",
          name: "/J002",
          component: J002,
        },
        {
          path: "/C002",
          name: "/C002",
          component: C002,
        },
        {
          path: "/S002",
          name: "/S002",
          component: S002,
        },
        {
          path: "/F003",
          name: "/F003",
          component: F003,
        },
        {
          path: "/M002",
          name: "/M002",
          component: M002,
        },
        {
          path: "/M012",
          name: "/M012",
          component: M012,
        },
        {
          path: "/S001",
          name: "/S001",
          component: S001,
        },
        {
          path: "/R001",
          name: "/R001",
          component: R001,
        },
        {
          path: "/O002",
          name: "/O002",
          component: O002,
        },
        {
          path: "/O003",
          name: "/O003",
          component: O003,
        },
        {
          path: "/D003",
          name: "/D003",
          component: D003,
        },
        {
          path: "/PCA01",
          name: "/PCA01",
          component: PCA01,
        },
        {
          path: "/S00101",
          name: "/S00101",
          component: S00101,
        },
        {
          path: "/C00101",
          name: "/C00101",
          component: C00101,
        },
        {
          path: "/A001",
          name: "/A001",
          component: A001,
        },
        {
          path: "/A002",
          name: "/A002",
          component: A002,
        },
        {
          path: "/A003",
          name: "/A003",
          component: A003,
        },
        {
          path: "/B001",
          name: "/B001",
          component: B001,
        },
        {
          path: "/B002",
          name: "/B002",
          component: B002,
        },
        {
          path: "/P001",
          name: "/P001",
          component: P001,
          meta: { title: '引当計画管理画面' }
        },
        {
          path: "/P002",
          name: "/P002",
          component: P002,
          meta: { title: '引当計画詳細画面' }
        },
        {
          path: "/P001-test",
          name: "/P001-test",
          component: P001Test,
          meta: { title: '引当計画管理画面テスト' }
        },
      ],
    },
  ],
});

// 2つのbeforeEachを1つに統合
router.beforeEach((to, from, next) => {
  // 1. 重複ナビゲーションを防ぐ
  if (to.path === from.path) {
    return;
  }
  
  // 2. ログインページや公開ページは除外
  if (to.path === '/login' || to.path === '/') {
    next();
    return;
  }
  
  // 3. 権限チェック
  const userRole = sessionStorage.getItem('userRole') || '3';
  if (hasMenuPermission(to.path, userRole)) {
    next();
  } else {
    // 権限がない場合はダッシュボードにリダイレクト
    // ただし、既にダッシュボードにいる場合は無限ループを防ぐ
    if (to.path !== '/D001-dashboard') {
      next('/D001-dashboard');
    } else {
      next();
    }
  }
});

// ナビゲーションエラーハンドリングを改善
router.onError((error) => {
  // ナビゲーションキャンセルエラーは無視
  if (error.name === 'NavigationDuplicated' || 
      error.name === 'NavigationCancelled' ||
      error.message && error.message.includes('Navigation cancelled')) {
    return;
  }
  console.error('Router error:', error);
});

// router.pushのエラーハンドリングも改善
const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => {
    // ナビゲーションキャンセルエラーは無視
    if (err.name === 'NavigationDuplicated' || 
        err.name === 'NavigationCancelled' ||
        (err.message && err.message.includes('Navigation cancelled'))) {
      return Promise.resolve();
    }
    return Promise.reject(err);
  });
};

//检测是否带有JSESSIONID；没有就跳到登录页；
// router.beforeEach(function (to, from, next) {
//   if (!getCookie("JSESSIONID")) {
//     if (to.path !== '/login') {
//       delCookie('JSESSIONID')
//       return next()
//     }
//   }
//   next()
// });

// getCookie関数はmain.jsで定義済み

// delCookie関数はmain.jsで定義済み

// 権限チェック用のインポート
import { hasMenuPermission } from '@/config/menuPermissions.js';

// ナビゲーションガードを追加
// router.beforeEach((to, from, next) => {
//   const userRole = sessionStorage.getItem('userRole') || '3';
  
//   // ログインページや公開ページは除外
//   if (to.path === '/login' || to.path === '/') {
//     next();
//     return;
//   }
  
//   // 権限チェック
//   if (hasMenuPermission(to.path, userRole)) {
//     next();
//   } else {
//     // 権限がない場合はダッシュボードにリダイレクト
//     next('/D001-dashboard');
//   }
// });

export default router;

export const keepAlivePages = [
  "F001",
  "G001",
  "H001",
  "J001",
  "K001",
  "M001",
  "M011",
  "O001",
  "O002",
  "Q001",
  "Q002",
  "R001",
  "E001",
  "S001",
  "C001",
  "S00101",
  "C00101",
  "A001",
  "A002",
  "A003",
  "P001",
  "P002",
];



// WEBPACK FOOTER //
// ./src/router/index.js